import {
  AnimatePresenceProps,
  AnimatePresence as AnimatePresenceRoot,
} from 'framer-motion'
import { FC, ReactNode } from 'react'

export const AnimatePresence = AnimatePresenceRoot as unknown as FC<
  AnimatePresenceProps & { children: ReactNode }
>
